const WINDOW_MS = 24 * 60 * 60 * 1000;

export function remainingWindowMs(lastVisitorAt: string | null | undefined, now = Date.now()): number {
  if (!lastVisitorAt) return 0;
  const ts = new Date(lastVisitorAt).getTime();
  if (!Number.isFinite(ts)) return 0;
  return Math.max(0, WINDOW_MS - (now - ts));
}

export function formatWhatsappWindowRemaining(ms: number): string {
  if (ms <= 0) return 'Ventana cerrada';
  const totalSec = Math.ceil(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  if (h > 0) return `${h} h ${m} min`;
  if (m > 0) return `${m} min ${s} s`;
  return `${s} s`;
}
